import { useQuery } from 'react-query';
import { useEffectOnce } from 'react-use';
import { captureMessage } from '@sentry/react';
import { Loader } from 'components/Loader';
import { ContactInfoContext, withContactInfoMachineState } from 'domains/signup/contactInfo/data/ContactInfoContext';
import { OfferPhoneCall } from 'domains/signup/livePhoneCalls/Components/OfferPhoneCall';
import { getLiveCallsConfig, isLiveCallAvailable } from 'domains/signup/livePhoneCalls/contentful';
import { getErrorMessage } from 'domains/api/errors';

const ContactInfoWrapper = () => {
  const offerLivePhoneCall = ContactInfoContext.useSelector(({ context }) => context.machineConfig.offerLivePhoneCall);
  const { send } = ContactInfoContext.useActorRef();

  const onContinueToSchedule = () => {
    send({
      type: 'skipPhoneCall',
    });
  };

  const onDataError = (e: unknown) => {
    captureMessage(getErrorMessage(e));
    onContinueToSchedule();
  };

  const { isSuccess, data } = useQuery(['contentful-live-call-config'], getLiveCallsConfig, {
    retry: false,
    onError: onDataError,
    onSuccess: configData => {
      try {
        if (!isLiveCallAvailable(configData, new Date())) {
          onContinueToSchedule();
        }
      } catch (e) {
        onDataError(e);
      }
    },
  });

  useEffectOnce(() => {
    if (!offerLivePhoneCall) {
      onContinueToSchedule();
    }
  });

  if (!isSuccess) {
    return <Loader defaultStyles />;
  }

  return (
    <OfferPhoneCall
      onContinueToSchedule={onContinueToSchedule}
      phoneNumber={data.configuration.expressablePhoneNumber}
    />
  );
};

export const ContactInfoOfferLivePhoneCall = withContactInfoMachineState(ContactInfoWrapper, 'offerLivePhoneCall');
